import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { binaries } from 'types/Common';
// Circular dependency
import { expenseStatuses } from 'store/expenses/expenses.types';
import { shopItemCategories } from 'types/MarketplaceItems';
import { benefitStatuses } from 'store/benefits';
import { employmentStatuses } from './employees.types';

export const employeesFiltersSchema = z
  .object({
    name: z.string().catch(''),
    email: z.string().catch(''),
    phone: z.string().catch(''),
    search: z.string().catch(''),
    employees: z.array(z.string()).catch([]),
    employeeGroups: z.array(z.string()).catch([]),
    status: z.array(z.enum(employmentStatuses)).catch([]),
    hiredAt: dateRangeSchema,
    customCategory: z.string().catch(''),
    customCategoryValues: z.array(z.string()).catch([]),
    isAppUser: z.enum(binaries).nullable().catch(null),
    companies: z.array(z.string()).catch([]),
    departments: z.array(z.string()).catch([]),
    teams: z.array(z.string()).catch([]),
    orgStructure: z.array(z.string()).catch([]),
    birthdaySoon: z.enum(binaries).nullable().catch(null),
    workAnniversarySoon: z.enum(binaries).nullable().catch(null),
    emailConsent: z.enum(binaries).nullable().catch(null),
    phoneNumberConsent: z.enum(binaries).nullable().catch(null),
    birthdateConsent: z.enum(binaries).nullable().catch(null),
  })
  .merge(paginationFiltersSchema)
  .merge(sortFiltersSchema);

export const employeeJobTitlesFiltersSchema = z
  .object({
    search: z.string().catch(''),
  })
  .merge(paginationFiltersSchema);

export const employeeExpensesFiltersSchema = z
  .object({
    date: dateRangeSchema,
    createdAt: dateRangeSchema,
    source: z.array(z.string()).catch([]),
    categories: z.array(z.enum(shopItemCategories)).catch([]),
    status: z.array(z.enum(expenseStatuses)).catch([]),
  })
  .merge(paginationFiltersSchema);

export const employeeWalletBenefitsFiltersSchema = z
  .object({
    benefits: z.array(z.string()).catch([]),
    status: z.array(z.enum(benefitStatuses)).catch([]),
  })
  .merge(paginationFiltersSchema);
